'use strict';
define([
    'angular',
    'modules/project/wizard/wizard.controller'
], function (angular, ProjectWizardCtrl) {
    var app = angular.module('app.project.wizard', []);
    app.controller('ProjectWizardCtrl', ProjectWizardCtrl);
    return app;
});
